/* eslint camelcase: 0 */
import { Query } from '@/infrastructure/network/Upstream/schema'
import { EmptyOptionsPropsFactory, IOptionsProps } from '@/entities/Upstream/Options'

export const toOptionsProps = (props?: Query): IOptionsProps => {
  if (!props) {
    return EmptyOptionsPropsFactory()
  }
  const { page, take } = props
  return EmptyOptionsPropsFactory({
    page,
    itemsPerPage: take
  })
}
